<template>
  <div class="container-fluid">
    <div class="row">
      <VeeForm @submit="onSubmit">
        <modal-form
          v-model="isModalVisible"
          @on-cancel="() => (isModalVisible = false)"
          :title="isEditMode ? 'Update account' : 'Add new account'"
          width="40%"
        >
          <template #bodyForm>
            <dynamic-form :schema="formSchema" :formData="formData" />
          </template>
        </modal-form>
      </VeeForm>
      <accounts-table
        ref="accountListRef"
        :columnDefs="accountColumns"
        @open-modal="handleNewAccount"
      />
    </div>
  </div>
</template>

<script>
import { Form as VeeForm } from "vee-validate";
import { defineComponent, ref, onMounted } from "vue";
import { useStore } from "vuex";

import AccountsTable from "../components/Managment/Accounts/AccountsTable.vue";
import DynamicForm from "@/components/DynamicForm.vue";
import ModalForm from "@/components/ModalForm.vue";
import { userForm as formSchema } from "@/constants/formSchemes";
import { accountColumns } from "@/constants/tableColumns";
import { showAlert } from "@/utils/alerts";

export default defineComponent({
  name: "AccountsComponent",
  components: {
    VeeForm,
    ModalForm,
    DynamicForm,
    AccountsTable,
  },

  setup() {
    const store = useStore();
    const isModalVisible = ref(false);
    const isEditMode = ref(false);

    const formData = ref({
      id: 0,
      name: "",
      sigla: "",
      mainEmail: "",
    });

    const accountListRef = ref(null);

    const onSubmit = async (values, { resetForm }) => {
      isModalVisible.value = false;
      resetForm();
      await store.dispatch(`accounts/addUser`, {
        ...values,
        cancelExpiration: true,
      });
      refreshAccounts();

      if (store.getters["accounts/isTransactionSuccess"]) {
        showAlert(
          !isEditMode.value
            ? "User has been created!"
            : "User has been updated",
          "You can now manage this information in the list",
          "success",
        );
      }
    };

    const refreshAccounts = () => {
      accountListRef.value.getAccounts();
    };

    const handleNewAccount = () => {
      isModalVisible.value = true;
    };

    onMounted(() => {
      store.state.hideConfigButton = false;
      store.state.showNavbar = true;
      store.state.showSidenav = true;
      store.state.showFooter = true;
    });

    return {
      isModalVisible,
      isEditMode,
      formSchema,
      formData,
      accountListRef,
      accountColumns,
      onSubmit,
      handleNewAccount,
    };
  },
});
</script>
